import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityDepartamentosLoadFailure,
  entityDepartamentosLoadSuccess,
  entityDepartamentosLoadRequest
} from './entity-departamentos.actions';

import { DepartamentosService } from '@rpe/registro-personas-empresas-lib/src/lib/departamentos/departamentos.service';

@Injectable()
export class DepartamentosEffects {
  // load
  loadRequestDepartamentos = createEffect(() =>
    this.actions$.pipe(
      ofType(entityDepartamentosLoadRequest),
      mergeMap(() =>
        this.departamentosService.getDepartamentos().pipe(
          map((items) => entityDepartamentosLoadSuccess({ items })),
          catchError((error) => of(entityDepartamentosLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private departamentosService: DepartamentosService
  ) {
    this.departamentosService.url = environment.apiUrl;
  }
}
